<template>
    <div class="dateRangePicker-container">
        <label><i class="fa fa-calendar" :class="{disabled: disabled}"></i></label>
        <input dusk="date-picker-input" ref="input" type="text" readonly="readonly" class="dateRangePicker-input form-control" :disabled="disabled"/>
    </div>
</template>

<script>
    require( 'select2/dist/js/select2.full.js');
    window.daterangepicker = require('js/libs/br-bootstrap-daterangepicker/daterangepicker');

    export default {
        props: {
            startDate: {
                type: [String, Object],
                default() { return moment().subtract(7, 'days'); }
            },
            endDate: {
                type: [String, Object],
                default() { return moment(); }
            },
            dateFormat: {
                type: String,
                default() { return 'MM/DD/YYYY';}
            },
            disabled: {
                type: Boolean,
                default() { return false;}
            }
        },
        data () {
            return {
                ranges: {
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'Month to Date': [moment().startOf('month'), moment().endOf('month')],
                    'Previous Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'Last 3 Months': [moment().subtract(2, 'month').startOf('month'), moment().endOf('month')],
                    'Last 12 Months': [moment().subtract(11, 'month').startOf('month'), moment().endOf('month')],
                }
            };
        },
        mounted () {
            let self = this;
            $(this.$refs.input).daterangepicker({
                    locale: { format: this.dateFormat },
                    alwaysShowCalendars: true,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    maxDate: this.endDate,
                    ranges: this.ranges,
                    showFrequencyDropDown: false,
                    preferredFrequencies: { h : 0, d: 31, w: 140, m: 365, q: 1200 },
                    validFrequencies: { 0: ['h'], 20: ['d'], 30: ['d', 'w'], 90: ['w', 'm'], 600: ['m', 'q'], 1200: ['q'] }
                },
                (start, end, label, frequency) => {
                    self.$emit('update', start, end, frequency)
                });
        },
        watch: {
            startDate(value) {
                $(this.$refs.input).data('daterangepicker').setStartDate(value);
            },
            endDate(value) {
                $(this.$refs.input).data('daterangepicker').setEndDate(value);
            }
        }
    };
</script>

<style>
    .dateRangePicker-container {
        position: relative;
        padding: 2px 0;
    }
    .dateRangePicker-input.form-control {
        background: transparent;
        width: 295px;
        padding-left: 50px;
        z-index: 2;
        color: #666;
    }
    .dateRangePicker-input.form-control:disabled,
    .dateRangePicker-container .disabled {
        opacity: .5;
    }
    .dateRangePicker-container label {
        position: absolute;
        left: 15px;
        top: 13px;
        z-index: 1;
    }
</style>
